import React from "react";
import { TextPromptProposalChips } from "@/components/flow/build/Steps/Prompt/SidebarContent/Annotate/TextPromptProposalChips";

interface NoResultsEmptyStateProps {
    labelName: string;
}

export const NoResultsEmptyState: React.FC<NoResultsEmptyStateProps> = ({ labelName }) => {
    return (
        <div className="flex flex-col gap-3 border-t border-gray-300 px-4 pt-4">
            <p className="text-xs font-normal text-tertiary">
                No objects found. Delete or try another word:{" "}
            </p>
            {/* Hide the "Try these:" header from TextPromptProposalChips using CSS */}
            <div className="[&>div>div:first-child]:hidden">
                <TextPromptProposalChips
                    isDisabled={false}
                    showPoweredBy={false}
                    sourceLabel={labelName}
                />
            </div>
        </div>
    );
};
